module.exports = __webpack_public_path__ + "frontend/images/landlords/landlords-best-quotes-87cb9bb24f480ec96b05c9f2d7d8345a.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/landlords/landlords-best-quotes.png
// module id = 375
// module chunks = 2